module.exports = __webpack_public_path__ + "static/media/laptop-phone.a1cfaf14.png";